export function getLocaleFromLang(lang?: string) {
  switch (lang) {
    case 'es':
      return 'es-419'
    case 'fr':
      return 'fr-FR'
    default:
      return 'en-US'
  }
}
